import { Button, Form, Input, message, Space } from "antd";
import { useState } from "react";
import { serverFetch } from "../../server";
import { CloseOutlined } from "@ant-design/icons";
import { isMobile } from "../../extensions/design";
import VisitCardSelect from "./visit-card-select";

const VisitOneAdd = ({ onClose, defaultCardCode }) => {
  const [item, setItem] = useState({ comment: '', keyName: '', cardCode: defaultCardCode || null, saleId: null});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onValuesChange = (value) => {
    if ('cardCode' in value) {
      setItem(prev => ({...prev, ...value, keyName: value.cardCode ? prev.keyName : ''}));
      if (!value.cardCode) {
        form.setFieldValue('keyName', '');
      }
    } else {
      setItem({...item, ...value});
    }
  }

  const onSave = () => {
    setLoading(true);
    serverFetch("visit", { method: "POST", bodyData: item})
      .then(data => onClose(true, data.id))
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" style={isMobile ? {} : {width: 900}} onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Разовый визит</span>
          <CloseOutlined className="sport-section-title-close" onClick={onClose} style={{ zIndex: 9 }}   />
        </div>
        <Form form={form} layout={isMobile ? "inline" :""} initialValues={{ cardCode: defaultCardCode || null }} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={ !isMobile ? { span: 12 }: {}} colon={false} disabled={loading}>
          <Form.Item className={isMobile ? "record-form-item-with-margin-bottom-mobile" : ""} label="Ключ" name="keyName">
            <Input className={isMobile ? "client-abon-form-item" : ""} disabled={!!item.cardCode}/>
          </Form.Item>
          <Form.Item className={isMobile ? "record-form-item-with-margin-bottom-mobile" : ""} label="Доп. карта" name="cardCode">
            <VisitCardSelect disabled={loading} onCardData={card => form.setFieldValue('keyName', card?.name ?? '')} />
          </Form.Item>
          <Form.Item className={isMobile ? "record-form-item-with-margin-bottom-mobile" : ""} label="Коммент." name="comment">
            <Input className={isMobile ? "client-abon-form-item" : ""}/>
          </Form.Item>
          {isMobile ? <Button className="sport-btn" onClick={onSave} style={{width: "100%"}}>Открыть визит</Button>
            :<Form.Item label=" ">
            <Space>
                <Button className="sport-btn" onClick={onSave}>Открыть визит</Button>
                <Button className="sport-btn" onClick={() => onClose(false)}>Отмена</Button>
            </Space>
          </Form.Item>}
        </Form>

  </div>
  </div>
  </div>
}

export default VisitOneAdd;